/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UserState = {
    NoActivationSent: 'NoActivationSent',
    ActivationPending: 'ActivationPending',
    Activated: 'Activated',
    Archived: 'Archived'
} as const;
export type UserState = typeof UserState[keyof typeof UserState];


export function UserStateFromJSON(json: any): UserState {
    return UserStateFromJSONTyped(json, false);
}

export function UserStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserState {
    return json as UserState;
}

export function UserStateToJSON(value?: UserState | null): any {
    return value as any;
}

/**
 * Check if a given object implements the UserState interface.
 */
 export function instanceOfUserState(value: any): value is UserState {
    return Object.values(UserState).includes(value)
}

